import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export type VariableHistoryEntry = {
  id: string;
  eventType: string;
  occurredOn: string;
  createdByName: string;
  previousValue: string | null;
  updatedValue: string | null;
};

export const variableHistoryQueryAtom = createQueryAtomFactory(
  'brokerage.variableHistory',
  (params: { id: string }) => ({
    pricingVariableHistory: {
      __args: { id: params.id },
      id: true,
      eventName: true,
      metadata: {
        occurredOn: true,
      },
      createdByUser: {
        id: true,
        firstName: true,
        lastName: true,
      },
      payload: true,
    },
  }),
  {
    select: (data): VariableHistoryEntry[] => {
      if (!data?.pricingVariableHistory) return [];
      return data.pricingVariableHistory.map((event) => {
        let parsedPayload: Record<string, unknown> = {};
        try {
          parsedPayload =
            typeof event.payload === 'string'
              ? JSON.parse(event.payload)
              : ((event.payload as Record<string, unknown>) ?? {});
        } catch {
          parsedPayload = {};
        }

        const eventType = Object.keys(parsedPayload)[0] ?? event.eventName;
        const eventData = parsedPayload[eventType] as
          | Record<string, unknown>
          | undefined;

        const previousVariable = eventData?.previousVariable as
          | Record<string, unknown>
          | undefined;
        const updatedVariable = eventData?.updatedVariable as
          | Record<string, unknown>
          | undefined;
        const variable = (eventData?.variable ?? eventData) as
          | Record<string, unknown>
          | undefined;

        const previousValue =
          previousVariable?.value != null
            ? String(previousVariable.value)
            : null;
        const updatedValue =
          updatedVariable?.value != null
            ? String(updatedVariable.value)
            : variable?.value != null
              ? String(variable.value)
              : null;

        return {
          id: event.id,
          eventType,
          occurredOn: event.metadata.occurredOn,
          createdByName: event.createdByUser
            ? `${event.createdByUser.firstName ?? ''} ${event.createdByUser.lastName ?? ''}`.trim()
            : 'System',
          previousValue,
          updatedValue,
        };
      });
    },
  },
);
